import React from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  pure,
  setDisplayName,
  lifecycle,
  withHandlers,
  setPropTypes
} from 'recompose';

const InfiniteScroller = ({ children }) => <div>{children}</div>;

function getDistFromBottom() {
  const scrollPosition = window.pageYOffset;
  const windowSize = window.innerHeight;

  const documentHeight = Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight
  );

  return Math.max(documentHeight - (scrollPosition + windowSize), 0);
}

export default compose(
  setDisplayName('InfiniteScrollerCore'),
  withHandlers({
    handleScroll: ({ loadMore, hasMore }) => () => {
      const distBottom = getDistFromBottom() === 0 || getDistFromBottom() < 3;
      if (distBottom && !hasMore) {
        loadMore();
      }
    }
  }),
  lifecycle({
    componentDidMount() {
      window.addEventListener('scroll', this.props.handleScroll);
    },
    componentWillUnmount() {
      window.removeEventListener('scroll', this.props.handleScroll);
    }
  }),
  setPropTypes({
    children: PropTypes.node,
    hasMore: PropTypes.bool,
    handleScroll: PropTypes.func
  }),
  pure
)(InfiniteScroller);
